module.exports = __webpack_public_path__ + "media/images/subject_img/CLASSICS-ARCHAEOLOGY-7c686e78a7f90ee97ef3bd43621903be.jpg";